import api from '../utils/api';

const exchangeService = {
  // ---------- 프로필 ----------
  getMyProfile: () => api.get('/api/exchange/profile/me'),
  saveProfile: (data) => api.post('/api/exchange/profile', data),
  uploadProfilePhoto: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/exchange/profile/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  // 사진 조회 경로(/api/exchange/profile/photo/{id})는 로그인이 필요해서, 일반 <img src=...>로는
  // JWT 토큰이 안 실려서 401이 난다. axios(api)로 인증 헤더를 포함해서 blob으로 받은 다음
  // 프론트에서 URL.createObjectURL()로 바꿔서 보여줘야 한다.
  getProfilePhotoBlob: (photoUrl) => api.get(photoUrl, { responseType: 'blob' }),

  // ---------- 매칭 ----------
  getCandidates: () => api.get('/api/exchange/matching/candidates'),
  sendMatchRequest: (receiverId) => api.post('/api/exchange/match-requests', { receiverId }),
  getReceivedRequests: () => api.get('/api/exchange/match-requests/received'),
  getSentRequests: () => api.get('/api/exchange/match-requests/sent'),
  acceptMatchRequest: (id) => api.put(`/api/exchange/match-requests/${id}/accept`),
  rejectMatchRequest: (id) => api.put(`/api/exchange/match-requests/${id}/reject`),
  getMyMatches: () => api.get('/api/exchange/matches'),

  // ---------- 채팅 ----------
  getChatRooms: () => api.get('/api/exchange/chat-rooms'),
  getMessages: (matchId, afterId) =>
    api.get(`/api/exchange/matches/${matchId}/messages`, { params: afterId ? { afterId } : {} }),
  sendMessage: (matchId, content) =>
    api.post(`/api/exchange/matches/${matchId}/messages`, { content }),
  markMessagesRead: (matchId) =>
    api.put(`/api/exchange/matches/${matchId}/messages/read`),

  // ---------- 영상통화 ----------
  startCall: (matchId) => api.post(`/api/exchange/matches/${matchId}/calls/start`),
  endCall: (callSessionId) => api.post(`/api/exchange/calls/${callSessionId}/end`),
  getRemainingCallSeconds: () => api.get('/api/exchange/calls/remaining-seconds'),
  getCallStatus: (matchId) => api.get(`/api/exchange/matches/${matchId}/call-status`),

  // ---------- 신고 ----------
  sendReport: (targetId, reason) => api.post('/api/exchange/reports', { targetId, reason }),
};

export default exchangeService;
